/* eslint-disable prettier/prettier */
export const currentState =(state)=>{    
return state.status
}
export const username =(state)=>{    
    if(state.user===null){
        return 0
    }else{
    return `${state.user.nombres||''}  ${state.user.primer_apellido||''}  ${state.user.segundo_apellido||''}`
    }    
   }
export const email =(state)=>{
    if (state.user===null){
        return 0
    }else{
    return `${state.user.correo_electronico}`
    }
   }
   export const image = (state) => {
    if (state.user===null){
        return 0
    }else{
        return `${state.user.imagen_segip}`
    }
   }
   export const nombre_recinto_penitenciario = (state) => {
    if (state.user===null){
        return 0
    }else{
        return `${state.user.nombre_recinto_penitenciario}`
    }
   }
   export const departamento_centro_penitenciario = (state) => {
    if (state.user===null){
        return 0
    }else{
        return `${state.user.departamento_centro_penitenciario}`
    }
   }
   export const departamento_supervisar = (state) => {
    if (state.user===null){
        return 0
    }else{
        return `${state.user.departamento_supervisar}`
    }
   }
   export const id_recinto = (state) => {
    if (state.user===null){
        return 0
    }else{
        return `${state.user.cod_recinto_penitenciario}`
    }
   }
   export const rol = (state) => {
    if (state.rol===null){
        return 0
    }else{
        return `${state.rol}`
    }
   
   }